var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"page-sizes":[10, 20, 30, 40],"page-size":_vm.pagination.PageSize,"layout":"prev, pager, next, total, jumper","total":_vm.pagination.total},on:{"current-change":_vm.currentChange}})}
var staticRenderFns = []

export { render, staticRenderFns }